import React, { useEffect, useState } from 'react';
import { format } from 'date-fns';
import { Card } from 'reactstrap';
import * as Icon from 'react-feather';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { useDebouncedCallback } from 'use-debounce';

import AddEditDncModal from './AddEditDncModal';
import CallexLoader from '../../../components/CallexLoader';
import Pagination from '../../../components/form/Pagination';
import AdminHeader from '../../../components/header/AdminHeader';
import DeleteConfirmationModal from '../../../components/Modals/DeleteConfirmationModal';

import {
  dncDelete,
  dncListExport,
  dncListGet,
  useDncList
} from '../../../store/slices/tenantSlices/incomingSlice';
import ImportDncModal from './ImportDncModal';
import { checkModulePermission } from '../../../utils/common';
import { useUserRolePermission } from '../../../store/slices/authSlice';

const Dnc = () => {
  const dispatch = useDispatch();
  const dncList = useDncList();
  const userRolePermission = useUserRolePermission();

  const [openAddModal, setOpenAddModal] = useState(false);
  const [openImportModal, setOpenImportModal] = useState(false);
  const [isDeleteImports, setIsDeleteImports] = useState(false);
  const [editRecord, setEditRecord] = useState(null);
  const [isEdit, setIsEdit] = useState(null);
  const [isDeleteId, setIsDeleteId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  // const [csvReportData, setCsvReportData] = useState([]);
  const [isExporting, setIsExporting] = useState(false);
  const [isCsvDownload, setIsCsvDownload] = useState(false);
  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    search: undefined
  });

  const fetchDncList = useDebouncedCallback(async () => {
    setIsLoading(true);
    try {
      const payload = { ...filter };
      await dispatch(dncListGet(payload)).unwrap();
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log('error', error);
    }
  }, 500);

  const deleteBreak = async () => {
    try {
      const response = await dispatch(dncDelete(isDeleteId)).unwrap();
      if (response) {
        toast.success('Record deleted successfully');
        if (dncList?.data?.length === 1) {
          setFilter({ ...filter, page: filter?.page > 1 ? filter.page - 1 : 1 });
        } else {
          fetchDncList();
        }
        setIsDeleteId(null);
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  useEffect(() => {
    fetchDncList();
  }, [filter]);

  // const csvHeaderData = [
  //   { label: 'Phone Number', key: 'phoneNumber' },
  //   { label: 'Type', key: 'type' },
  //   { label: 'Add By', key: 'add_by' },
  //   { label: 'Active', key: 'active' }
  // ];

  // const prepareExportProps = () => {
  //   const data = csvReportData || [];
  //   return { headers: csvHeaderData, data, filename: 'DNC.csv' };
  // };

  const handleExportCSV = async () => {
    setIsExporting(true);
    try {
      const response = await dispatch(dncListExport()).unwrap();
      const url = window.URL.createObjectURL(response);
      const link = document.createElement('a');
      link.href = url;
      link.download;
      link.click();
      window.URL.revokeObjectURL(url);
      setIsExporting(false);
    } catch (error) {
      setIsExporting(false);
      console.log('Error exporting CSV:', error);
    }
  };

  return (
    <div>
      <AdminHeader
        title="DNC"
        isExpandSearch
        isAdd
        isImport
        isDeleteImport
        isManualExport
        isImportDisabled={!checkModulePermission('is_import', 'DNC', userRolePermission)}
        isExportDisabled={!checkModulePermission('is_export', 'DNC', userRolePermission)}
        isDeleteImportDisabled={!checkModulePermission('is_delete', 'DNC', userRolePermission)}
        isAddDisabled={!checkModulePermission('is_add', 'DNC', userRolePermission)}
        onImportClick={() => setOpenImportModal(true)}
        onDeleteImportClick={() => {
          setIsDeleteImports(true);
          setOpenImportModal(true);
        }}
        onAddClick={() => setOpenAddModal(true)}
        // csvProps={prepareExportProps()}
        isExport={dncList?.data?.length > 0}
        onExportClick={() => handleExportCSV()}
        setIsCsvDownload={setIsCsvDownload}
        isCsvDownload={isCsvDownload}
        isExporting={isExporting}
        addBtnName="Add DNC"
        searchPlaceholder="Search DNC"
        search={filter.search}
        handelSearch={(e) => setFilter({ ...filter, search: e.target.value })}
      />
      {isLoading ? (
        <Card
          className="p-0 d-flex justify-content-center align-items-center m-0"
          style={{ height: 'calc(100vh - 165px)' }}>
          <CallexLoader />
        </Card>
      ) : dncList?.data?.length > 0 &&
        checkModulePermission('is_view', 'DNC', userRolePermission) ? (
        <Card className="p-0 position-relative m-0">
          <div className="daily-report-table" style={{ height: 'calc(100vh - 210px)' }}>
            <table className="report-list-table">
              <thead>
                <tr>
                  <th>Created Date</th>
                  <th>Updated Date</th>
                  <th>Phone Number</th>
                  <th>Type</th>
                  <th>Add By</th>
                  <th>Active</th>
                  <th className="text-center" style={{ width: '90px' }}>
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {dncList?.data?.map((val, index) => {
                  return (
                    <tr key={index}>
                      <td>{format(val?.createdAt, 'yyyy-MM-dd HH:mm:ss') || '-'}</td>
                      <td>{format(val?.updatedAt, 'yyyy-MM-dd HH:mm:ss') || '-'}</td>
                      <td>{val?.phoneNumber}</td>
                      <td>{val?.type}</td>
                      <td>{val?.add_by}</td>
                      <td>{String(val?.active)}</td>
                      <td>
                        <div className="d-flex justify-content-around align-items-center">
                          <div
                            className={`cursor-pointer text-info ${
                              !checkModulePermission('is_edit', 'DNC', userRolePermission)
                                ? 'callex-disabled'
                                : ''
                            }`}>
                            <Icon.Edit
                              size={16}
                              onClick={() => {
                                if (checkModulePermission('is_edit', 'DNC', userRolePermission)) {
                                  setEditRecord(val);
                                  setIsEdit(true);
                                  setOpenAddModal(true);
                                }
                              }}
                            />
                          </div>
                          <div
                            className={`cursor-pointer text-danger ${
                              !checkModulePermission('is_delete', 'DNC', userRolePermission)
                                ? 'callex-disabled'
                                : ''
                            }`}>
                            <Icon.Trash
                              size={16}
                              onClick={() => {
                                if (checkModulePermission('is_delete', 'DNC', userRolePermission)) {
                                  setIsDeleteId(val?.id);
                                }
                              }}
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="position-absolute w-100" style={{ bottom: '-56px' }}>
            <Pagination
              totalCount={dncList?.total}
              limit={dncList?.limit}
              page={dncList?.page}
              onLimitChange={(val) => {
                setFilter({ ...filter, page: 1, limit: val });
              }}
              onPageClick={(val) => setFilter({ ...filter, page: val })}
              lastPageClick={(val) => setFilter({ ...filter, page: val })}
              firstPageClick={(val) => setFilter({ ...filter, page: val })}
              onRefreshClick={() => fetchDncList()}
            />
          </div>
        </Card>
      ) : (
        <Card
          className="p-0 d-flex justify-content-center align-items-center no-data m-0"
          style={{ height: 'calc(100vh - 165px)' }}>
          No data available
        </Card>
      )}
      <DeleteConfirmationModal
        isOpen={!!isDeleteId}
        onCloseClick={() => setIsDeleteId(null)}
        onDeleteClick={() => deleteBreak()}
      />
      <AddEditDncModal
        isOpen={openAddModal}
        onCloseClick={(apiCall = false) => {
          setOpenAddModal(false);
          setEditRecord(null);
          setIsEdit(false);
          if (apiCall) {
            fetchDncList();
          }
        }}
        editRecord={editRecord}
        isEdit={isEdit}
      />
      <ImportDncModal
        isDeleteImport={isDeleteImports}
        isOpen={openImportModal}
        onCloseClick={(apiCall = false) => {
          setOpenImportModal(false);
          setIsDeleteImports(false);
          if (apiCall) {
            fetchDncList();
          }
        }}
      />
    </div>
  );
};

export default Dnc;
